import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../components/CustomDataGrid";
import baseURL from "../../config/api";
import { useLocation, useNavigate } from "react-router-dom";
import { statusColorCode } from "../../utils/statusColorCode";
import { TitleBar } from "../../components/TitleBar";
import useDelete from "../../hook/useDelete";
import { delete_EnrollmentStudent, post_ResendInvitationStudent } from "../../services/Class";
import useAuth from "../../hook/useAuth";
import DeletePopup from "../../components/DeletePopup";
import { PleasewaitPopup } from "../../components/PleasewaitPopup";
import { Box, CircularProgress, Typography } from "@mui/material";

const sideBarOption = ["Invited Students", "Students Progress"];

export const ClassSettings = () => {
    const { auth }: any = useAuth();
    const location = useLocation();
    const { id, title, selectedSideBar } = location.state || {};
    const navigate = useNavigate();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [refreshStudentList, setRefreshStudentList] = useState<boolean>(true);
    const [selectedSideBarOption, setSelectedSideBarOption] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const invitedStudentsColumns: GridColDef[] = [
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "userName",
            headerName: "User Name",
            type: "number",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "emailAddress",
            headerName: "Email Address",
            editable: false,
            sortable: false,
            flex: 1,
            minWidth: 100,
        },
        {
            field: "mobilPhoneNumber",
            headerName: "Phone Number",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "enrolledStatus",
            headerName: "Status",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                let color = {
                    colorBg: "#000000",
                    colorText: "#000000"
                };
                color = statusColorCode?.find((color: any) => color?.label === params?.value?.trim()?.toLowerCase()) || {
                    colorBg: "#000000",
                    colorText: "#000000"
                };

                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },
        {
            field: "enrollmentClassId",
            headerName: "Actions",
            type: "actions",
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Delete"
                    onClick={() => { handleOnDeleteStudent(params.row.enrollmentClassId) }}
                />,
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Re-send invite"
                    onClick={() => { handleReInviteStudent(params.row.enrollmentClassId) }}
                />,

            ]
        }
    ];
    const studentsProgressColumns: GridColDef[] = [
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <span className="underline text-[#0000ff] cursor-pointer" onClick={() => {
                        navigate("/teacher/students/progress", { state: { id: params?.row?.id, name: params?.row?.firstName + " " + params?.row?.lastName, classTitle: title, classId: id, courseId: params?.row?.courseId } })
                    }}>
                        {params?.value}
                    </span>
                );
            },
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "userName",
            headerName: "User Name",
            type: "number",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "emailAddress",
            headerName: "Email Address",
            editable: false,
            sortable: false,
            flex: 1,
            minWidth: 100,
        },
        {
            field: "mobilPhoneNumber",
            headerName: "Phone Number",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "progressValue",
            headerName: "Progress Value",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "totalValue",
            headerName: "Total Value",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
        },
        {
            field: "progress",
            headerName: "Progress",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: false,
            renderCell: (params) => {

                return (
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress
                            variant="determinate"
                            value={params.value}
                            enableTrackSlot
                        />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                variant="caption"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >{`${Math.round(params.value)}%`}</Typography>
                        </Box>
                    </Box>
                );
            }
        },

    ];

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [isSidebarOpen]);

    useEffect(() => {
        if (selectedSideBar) {
            setSelectedSideBarOption(Number(selectedSideBar));
        }
    }, [selectedSideBar])

    useEffect(() => {
        const newPaginationModel = {
            page: 0,
            pageSize: 10,
        };

        setPaginationModel(newPaginationModel);
        setSearchTableData([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSideBarOption])

    useEffect(() => {
        if (refreshStudentList) {
            const newPaginationModel = {
                page: 0,
                pageSize: 10,
            };

            setPaginationModel(newPaginationModel);
            setRefreshStudentList(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshStudentList]);

    useEffect(() => {
        if (id && selectedSideBarOption === 0) {
            invitedStudentsApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, id])

    const invitedStudentsApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}users/GetEnrolledLearnersForClassWithStatus/${id},${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.userWithStatusDto?.map((item: any, index: number) => {
                    return {
                        id: index,
                        enrollmentClassId: item.enrollmentClassId,
                        firstName: item.firstName,
                        lastName: item.lastName,
                        userName: item.userName,
                        emailAddress: item.emailAddress,
                        mobilPhoneNumber: item.mobilPhoneNumber,
                        enrolledStatus: item.enrolledStatus
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });


    }

    useEffect(() => {

        if (id && selectedSideBarOption === 1) {
            studentsProgressApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, id])


    const studentsProgressApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}users/GetEnrolledLearnersForClassWithStatusAndProgress/${id},${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.userWithStatusDto?.map((item: any) => {
                    return {
                        ...item,
                        progress: (item.progressValue / item.totalValue) * 100
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });


    }



    const handleReInviteStudent = (id: number) => {
        if (id) {
            setShowPleasewait(true);
            post_ResendInvitationStudent(id)
                .then((res) => {
                    setShowPleasewait(false);
                    setRefreshStudentList(true);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }


    const handleOnDeleteStudent = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this student?`,
                isDelete: (callback: any) => {
                    delete_EnrollmentStudent(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshStudentList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }



    return (
        <>
            <div className="p-4 min-h-80">
                <TitleBar
                    title={title}
                    subTitle="Students"
                    isBackTo={true}
                    backPath="/teacher/dashboard"
                    backToTitle="Back to Dashboard"
                />

                <div className="w-full py-8 md:flex">
                    <aside className="bg-white border-r border-gray-200 py-4 w-max max-md:hidden">
                        <nav className="space-y-4 text-sm w-max">
                            {
                                sideBarOption?.map((item: string, index) => (
                                    <div key={index} onClick={() => {
                                        navigate(".", {
                                            replace: true,
                                            state: { id, title },
                                        });
                                        setSelectedSideBarOption(index);
                                    }}>
                                        <button className={`font-medium ${selectedSideBarOption === index ? "text-primary bg-blue-100" : "text-gray-900 hover:text-primary hover:bg-blue-100"} w-full p-2 cursor-pointer flex items-center justify-start`}>{item}</button>
                                    </div>
                                ))
                            }
                        </nav>
                    </aside>

                    <div className="w-full p-3 border-b border-[#D0D0D0] md:hidden flex justify-end items-center">

                        {/* Mobile Menu Button */}
                        <button onClick={() => setSidebarOpen(true)}>
                            <span className="material-symbols-outlined text-3xl">menu</span>
                        </button>
                    </div>

                    {
                        selectedSideBarOption === 0 && (
                            <div className="p-4 w-full">
                                <div className="w-full mt-2 md:px-6 md:py-6 bg-white">
                                    <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                                        <div className={`flex justify-start items-center p-4 border-b border-[#E4E7EC]`}>
                                            <div className="flex items-center gap-1.5">

                                                <h2 className={`text-lg font-semibold text-[#1D2939]`}>Invited Students</h2>
                                            </div>

                                        </div>

                                        <CustomDataGrid
                                            filteredRows={searchTableData}
                                            columns={invitedStudentsColumns?.map(col => ({
                                                ...col,
                                                headerClassName: "bg-[#F9FAFB]",
                                            }))}
                                            loading={loading}
                                            totalLength={totalLength}
                                            paginationModel={paginationModel}
                                            setPaginationModel={setPaginationModel}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }


                    {
                        selectedSideBarOption === 1 && (
                            <div className="p-4 w-full">
                                <div className="w-full mt-2 md:px-6 md:py-6 bg-white">
                                    <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                                        <div className={`flex justify-start items-center p-4 border-b border-[#E4E7EC]`}>
                                            <div className="flex items-center gap-1.5">

                                                <h2 className={`text-lg font-semibold text-[#1D2939]`}>Students Progress</h2>
                                            </div>

                                        </div>

                                        <CustomDataGrid
                                            filteredRows={searchTableData}
                                            columns={studentsProgressColumns?.map(col => ({
                                                ...col,
                                                headerClassName: "bg-[#F9FAFB]",
                                            }))}
                                            loading={loading}
                                            totalLength={totalLength}
                                            paginationModel={paginationModel}
                                            setPaginationModel={setPaginationModel}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }

                </div>
            </div>

            {isSidebarOpen && (
                <div className="fixed inset-0 z-[10000] flex">

                    {/* BACKDROP */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-40"
                        onClick={() => setSidebarOpen(false)}
                    />

                    {/* SLIDING DRAWER */}
                    <div className="relative z-[10001] w-72 bg-white h-screen shadow-xl animate-slideIn pb-12">

                        {/* Header */}
                        <div className="flex items-center justify-end p-4 border-b">

                            <button onClick={() => setSidebarOpen(false)}>
                                <span className="material-symbols-outlined text-3xl">close</span>
                            </button>
                        </div>

                        {/* Lesson Items */}
                        <div className="overflow-y-auto max-md:h-[calc(100vh-200px)] p-2">
                            <nav className="space-y-4 text-sm w-full">
                                {
                                    sideBarOption?.map((item: string, index) => (
                                        <div key={index} onClick={() => {
                                            setSidebarOpen(false);
                                            navigate(".", {
                                                replace: true,
                                                state: { id, title },
                                            });
                                            setSelectedSideBarOption(index);
                                        }}>
                                            <button className={`font-medium ${selectedSideBarOption === index ? "text-primary bg-blue-100" : "text-gray-900 hover:text-primary hover:bg-blue-100"} w-full p-2 cursor-pointer flex items-center justify-start`}>{item}</button>
                                        </div>
                                    ))
                                }
                            </nav>
                        </div>
                    </div>
                </div>
            )}

            <DeletePopup />

            <PleasewaitPopup showPopup={showPleasewait} />
        </>

    )
}